import React from 'react'
import DropzoneField from '../../formFields/dropzoneField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <DropzoneField {...fieldProps} />
))
